import React from 'react';
import { Container, Row, Col, Card, Button, Badge } from 'react-bootstrap';
import { BsShieldCheck, BsClipboardCheck, BsFileEarmarkText, BsBank, BsTelephone, BsArrowRightCircle, BsCheckCircle } from 'react-icons/bs';
import LeadForm from "./js/components/LeadForm";
import bg from './images/banner/banner.jpg';

export default function LawPage() {
  return (
    <div className="law-page">

      {/* HERO / БАННЕР */}
      <section
        className="law-hero d-flex align-items-center"
        style={{
          minHeight: '60vh',
          backgroundImage: `url(${bg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          position: 'relative',
          color: '#fff'
        }}
      >
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(90deg, rgba(0,0,0,.6), rgba(0,0,0,.15))'
          }}
        />
        <Container className="position-relative">
          <Row className="align-items-center">
            <Col lg={8}>
              <h1 className="fw-bold mb-3" style={{ textShadow: '0 2px 10px rgba(0,0,0,.5)' }}>
                Правовые вопросы решаются проще с нашей командой
              </h1>
              <p className="lead mb-4" style={{ maxWidth: 800 }}>
                Не оставайтесь с проблемой один на один. Мы аккуратно разберёмся в вашей ситуации, защитим интересы и предложим понятный план действий — от консультации до результата.
              </p>
              <Button
                size="lg"
                variant="light"
                href="#consultation"
                className="d-inline-flex align-items-center"
              >
                Получить бесплатную консультацию <BsArrowRightCircle className="ms-2 ml-2" />
              </Button>
            </Col>
          </Row>
        </Container>
      </section>

      {/* УСЛУГИ */}
      <section className="py-5 bg-light">
        <Container>
          <Row className="mb-4">
            <Col>
              <h2 className="h3 fw-bold mb-2">Наши услуги</h2>
              <p className="text-muted mb-0">Полный цикл сопровождения: от первичной оценки до представительства в суде.</p>
            </Col>
          </Row>

          <Row xs={1} md={2} lg={4} className="g-4">
            <Col>
              <Card className="h-100 shadow-sm">
                <Card.Body>
                  <div className="display-6 mb-3"><BsTelephone /></div>
                  <Card.Title className="fw-bold">Первичная консультация</Card.Title>
                  <Card.Text className="text-muted">
                    Бесплатно уточняем детали, формируем приоритеты и намечаем первые шаги для быстрого старта.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card className="h-100 shadow-sm">
                <Card.Body>
                  <div className="display-6 mb-3"><BsClipboardCheck /></div>
                  <Card.Title className="fw-bold">Правовой анализ</Card.Title>
                  <Card.Text className="text-muted">
                    Проверяем договоры и документы, оцениваем риски и перспективы, объясняем понятным языком.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card className="h-100 shadow-sm">
                <Card.Body>
                  <div className="display-6 mb-3"><BsFileEarmarkText /></div>
                  <Card.Title className="fw-bold">Документы «под ключ»</Card.Title>
                  <Card.Text className="text-muted">
                    Готовим обращения, заявления и жалобы с учётом вашей задачи и требований инстанций.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card className="h-100 shadow-sm">
                <Card.Body>
                  <div className="display-6 mb-3"><BsBank /></div>
                  <Card.Title className="fw-bold">Защита интересов</Card.Title>
                  <Card.Text className="text-muted">
                    Представляем вас в судах и госорганах, держим в курсе каждого этапа и сроков.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* КАК ПОЛУЧИТЬ ПОМОЩЬ */}
      <section className="py-5">
        <Container>
          <Row className="mb-4">
            <Col>
              <h2 className="h3 fw-bold mb-2">Как получить помощь</h2>
              <p className="text-muted mb-0">Простой путь от обращения до понятного плана действий.</p>
            </Col>
          </Row>

          <Row className="g-4">
            {[
              'Свяжитесь с нами удобным способом — онлайн-форма или телефон.',
              'Коротко опишите ситуацию и при необходимости прикрепите документы.',
              'Получите бесплатную консультацию с разбором вариантов решения.',
              'Вместе с юристом согласуйте пошаговый план и сроки.'
            ].map((step, i) => (
              <Col md={6} key={i}>
                <Card className="h-100 border-0 shadow-sm">
                  <Card.Body className="d-flex">
                    <Badge bg="dark" pill className="mx-3 align-self-start">{i + 1}</Badge>
                    <div>
                      <Card.Text className="mb-0">{step}</Card.Text>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* ПОЧЕМУ ИМЕННО МЫ */}
      <section className="py-5 bg-light">
        <Container>
          <Row className="mb-4">
            <Col>
              <h2 className="h3 fw-bold mb-2">Почему именно мы</h2>
              <p className="text-muted mb-0">Открытая коммуникация, эффективность и персональный подход.</p>
            </Col>
          </Row>

        <Row>
          <Col lg={10}>
            <ul className="list-unstyled fs-5">
              {[
                'Опытные практикующие юристы и адвокаты.',
                'Бесплатная первичная консультация — без навязанных услуг.',
                'Индивидуальная стратегия под конкретную задачу.',
                'Прозрачные условия и предсказуемая стоимость.'
              ].map((item, idx) => (
                <li className="d-flex align-items-start mb-2" key={idx}>
                  <BsCheckCircle className="mx-2 mt-1 text-success" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </Col>
        </Row>
        </Container>
      </section>

      {/* БЕСПЛАТНАЯ КОНСУЛЬТАЦИЯ (с формой) */}
      <section id="consultation" className="py-5">
        <Container>
          <Row className="mb-4">
            <Col>
              <h2 className="h3 fw-bold mb-2">Бесплатная консультация юриста</h2>
              <p className="text-muted mb-0">
                Оставьте заявку — специалист свяжется с вами, проведёт первичный разбор и подскажет, с чего начать уже сейчас. Это бесплатно и помогает быстрее принять верные решения.
              </p>
            </Col>
          </Row>

          <Row className="g-4">
            <Col lg={6}>
              <Card className="shadow-sm border-0">
                <Card.Body>
                  {/* Используем вашу существующую форму */}
                  <LeadForm additional={'Заявка со страницы /law'} />
                </Card.Body>
              </Card>
            </Col>
            <Col lg={6}>
              <Card className="shadow-sm border-0 h-100">
                <Card.Body>
                  <h5 className="fw-bold mb-3">Что вы получите</h5>
                  <ul className="list-unstyled mb-4">
                    <li className="d-flex mb-2"><BsShieldCheck className="mx-2 mt-1" /> Индивидуальную оценку и приоритеты на старте</li>
                    <li className="d-flex mb-2"><BsShieldCheck className="mx-2 mt-1" /> Пошаговый план первоочерёдных действий</li>
                    <li className="d-flex mb-2"><BsShieldCheck className="mx-2 mt-1" /> Рекомендации по документам и срокам</li>
                    <li className="d-flex"><BsShieldCheck className="mx-2 mt-1" /> Понимание перспектив и рисков по делу</li>
                  </ul>
                  <p className="text-muted small mb-0">
                    Отправляя форму, вы подтверждаете согласие с Политикой конфиденциальности и Пользовательским соглашением (ссылки и модальные окна уже встроены в форму).
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

    </div>
  );
}
